export default __webpack_public_path__ + "static/media/information-blue.192f1ecd.svg";